import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'shadow',
      d: 'M-6,0.5h1.5v0.5h-1.5zM4.5,0.5h1.5v0.5h-1.5zM-5,1h2.5v0.5h-2.5zM2.5,1h2.5v0.5h-2.5z',
    },
    {
      paint: 'wallShade',
      d: 'M-1.5,-5.5h4.5v0.5h-4.5zM-3.5,-5h0.5v0.5h-0.5zM3.5,-5h0.5v0.5h-0.5zM-4.5,-4.5h0.5v0.5h-0.5zM-5,-4h0.5v1.5h-0.5zM5,-3.5h1v2h-1zM-1,-2.5h0.5v0.5h-0.5zM1.5,-2.5h0.5v1h-0.5zM2.5,-2.5h1.5v0.5h-1.5zM-2,-2h0.5v0.5h-0.5zM3,-2h1v0.5h-1zM3,-1.5h3v0.5h-3zM3,-1h0.5v0.5h-0.5zM5,-1h1v1h-1zM3.5,-0.5h0.5v0.5h-0.5zM3,0h1v1h-1zM4.5,0h1v0.5h-1zM-2.5,1h1v0.5h-1zM1.5,1h1v0.5h-1z',
    },
    {
      paint: 'church',
      d: 'M-3,-6h5.5v0.5h-5.5zM-4.5,-5.5h2v0.5h-2zM-5.5,-5h2v0.5h-2zM-5.5,-4.5h1v0.5h-1zM-6,-4h1v0.5h-1zM-5.5,-1.5h1v0.5h-1zM-4,-1h0.5v0.5h-0.5zM4,-1h0.5v0.5h-0.5zM-2,-0.5h1.5v0.5h-1.5zM0.5,-0.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'trunk',
      d: 'M-2.5,-5h5v0.5h-5zM-4,-4.5h8v0.5h-8zM-4.5,-4h9.5v0.5h-9.5zM-4.5,-3.5h1.5v0.5h-1.5zM3.5,-3.5h1v0.5h-1zM3.5,-3h0.5v0.5h-0.5zM-5,-2.5h1v1h-1zM2,-2.5h0.5v0.5h-0.5zM4,-2.5h1v1h-1zM-3,-2h1v1h-1zM-0.5,-2h1v1.5h-1zM2,-2h1v1h-1z',
    },
    {
      paint: 'path',
      d: 'M-3,-5h0.5v0.5h-0.5zM2.5,-5h1v0.5h-1zM4,-4.5h0.5v0.5h-0.5zM-3,-3.5h6.5v0.5h-6.5zM4.5,-3.5h0.5v0.5h-0.5zM-3.5,-3h7v0.5h-7zM4,-3h1v0.5h-1zM-2.5,-2.5h0.5v0.5h-0.5zM-0.5,-2.5h2v0.5h-2zM-2,-1.5h0.5v0.5h-0.5zM1.5,-1.5h0.5v0.5h-0.5zM-5,-1h0.5v1h-0.5zM-3,0h0.5v0.5h-0.5zM1.5,0h0.5v0.5h-0.5zM2.5,0h0.5v0.5h-0.5zM4,0h0.5v1h-0.5zM-2.5,0.5h1v0.5h-1zM2,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'epicMarble',
      d: 'M-0.5,-6.5h1v0.5h-1zM-4,-6h1v0.5h-1zM2.5,-6h0.5v0.5h-0.5zM-5,-5.5h0.5v0.5h-0.5zM-2.5,-5.5h1v0.5h-1zM-6,-5h0.5v1h-0.5zM-6,-3.5h1v2h-1zM-4.5,-3h1v0.5h-1zM-4,-2.5h1.5v0.5h-1.5zM-2,-2.5h1v0.5h-1zM-4,-2h1v0.5h-1zM-1.5,-2h1v1h-1zM0.5,-2h1v1h-1zM-6,-1.5h0.5v0.5h-0.5zM-4.5,-1.5h1.5v0.5h-1.5zM-6,-1h1v1h-1zM-4.5,-1h0.5v0.5h-0.5zM-3.5,-1h3v0.5h-3zM0.5,-1h2.5v0.5h-2.5zM3.5,-1h0.5v0.5h-0.5zM4.5,-1h0.5v0.5h-0.5zM-4,-0.5h2v0.5h-2zM-0.5,-0.5h1v0.5h-1zM3,-0.5h0.5v0.5h-0.5zM-5.5,0h2.5v0.5h-2.5zM-1.5,0h1v1h-1zM0.5,0h1v0.5h-1zM-4,0.5h1.5v0.5h-1.5zM0.5,0.5h1.5v0.5h-1.5zM2.5,0.5h0.5v0.5h-0.5zM-1.5,1h3v0.5h-3z',
    },
    {
      paint: 'boulder',
      d: 'M-4.5,-0.5h0.5v0.5h-0.5zM4,-0.5h1v0.5h-1zM-2.5,0h1v0.5h-1zM-0.5,0h1v1h-1zM2,0h0.5v0.5h-0.5zM-4.5,0.5h0.5v0.5h-0.5z',
    },
  ],
  pixels: 329,
};
export const sprites: readonly PixelSprite[] = [variant0];
